import { API_STATUS } from 'core-lib/constants/network';
import { useEffect } from 'react';
import Modal from 'ui-v2/components/Modal';
import useParkplusStoreV2 from '../../../hooks/useParkplusStoreV2';
import { trackPopupViewStoreV2 } from '../../../utils/events';
import CartItem from '../../Cards/CartItem';
import s from './CartActionPopup.module.scss';
import StoreLoader from '../../StoreLoader';

type CartActionPopupProps = {
  show: boolean;
  onClose: () => void;
};

export const CartActionPopup = ({ show, onClose }: CartActionPopupProps) => {
  const { cartData, cartApiStatus } = useParkplusStoreV2();
  useEffect(() => {
    if (show) {
      trackPopupViewStoreV2('cart_bs');
    }
  }, [show]);
  return (
    <Modal
      head={{
        show: true,
        title: 'Items added to your cart',
        onClose,
      }}
      show={show}
      rootStyle={{
        zIndex: 3,
      }}
      noPadding
    >
      <div className={s.root}>
        {cartData?.data?.map((item, index) => (
          <CartItem
            cartItem={item}
            onClose={onClose}
            key={item?.cartItemId}
            index={index}
            showDeliveryDate
          />
        ))}
      </div>
      <StoreLoader show={cartApiStatus === API_STATUS.in_progress} />
    </Modal>
  );
};
